var _style, _rect, _rect2, _rect3, _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .hola { font: italic 45px serif; color:#000;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 45,
    x: 0,
    y: 0,
    fill: "#aa151b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 90,
    x: 0,
    y: 45,
    fill: "#f1bf00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 45,
    x: 0,
    y: 135,
    fill: "#aa151b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 75,
    r: 10,
    fill: "#00aaff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 105,
    r: 25,
    fill: "#00aaff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 105,
    className: "hola"
  }, "Esp.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSpanish);
export default __webpack_public_path__ + "static/media/flag_spanish.d25c7dccf852f43e2683a70e6293df32.svg";
export { ForwardRef as ReactComponent };